import React from 'react';

import PackageDefs from '~app/pages/Pricing/lib/packages/packageDefs';
import PackageHeader from '~app/pages/Pricing/components/PackageHeader';
import { PackageHeaderProps } from '~pricing/components/Summary/types';

import useDetailsPackageHeaderStyles from './useStyles';

type DetailsHeader = {
  index: string;
};

type DetailsPackageHeaderProps = PackageHeaderProps & DetailsHeader;

export default function DetailsPackageHeader({
  comparisonSkuCosts,
  discountInfo,
  skuCosts,
  packageName,
  index,
}: DetailsPackageHeaderProps): JSX.Element {
  const { Highlighted, Package } = useDetailsPackageHeaderStyles({ packageName });
  const packageHeaderClassName = `${Package} ${PackageDefs[packageName]?.highlighted ? Highlighted : ''}`;

  return (
    <div className={packageHeaderClassName} style={{ gridArea: `package${index}` }}>
      <PackageHeader
        comparisonSkuCosts={comparisonSkuCosts}
        discountInfo={discountInfo}
        skuCosts={skuCosts}
        packageName={packageName}
      />
    </div>
  );
}
